import { useEffect } from "react";
import { Platform } from "react-native";

/**
 * Sets the meta description on web while the screen is focused.
 * Automatically clears it when the screen loses focus.
 *
 * @param {string} description - The meta description to set.
 */
export const setMetaDescription = (metaDescription) => {
  // added this to skip unit tests that run in a Node environment
  if (typeof document === "undefined") return;

  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "description";
    document.head.appendChild(meta);
    console.log("Meta description element created");
  }
  meta.content = metaDescription;
};

const MetaDescription = (metaDescription) => {
  useEffect(() => {
    if (Platform.OS === "web") {
      setMetaDescription(metaDescription);
    }
  }, [metaDescription]);
};

export default MetaDescription;
